import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CategoryGrid } from '../models/grid.models';

const getGridState = createFeatureSelector<CategoryGrid>('category-grid');

export const getGridDefault = createSelector(getGridState, (state: CategoryGrid) => state?.gridDefault);
export const getGridPageAllIds = createSelector(getGridState, (state: CategoryGrid) => state?.gridDefault?.idsFiltered);
export const getGridStudio = createSelector(getGridState, (state: CategoryGrid) => state?.gridStudio);
export const getPageProductIds = createSelector(getGridState, (state: CategoryGrid) => state?.gridDefault?.pageProductIds);
export const getPageProductIdsLength = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridDefault?.pageProductIds?.length);

export const gridDefaultFullyLoaded = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridDefault?.productsFullyLoaded);

export const getPageGridElements = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridStudio?.pageGridElements);

// #region GRID NEW COLLECTION
export const getGridNewCollection = createSelector(getGridState, (state: CategoryGrid) => state?.gridNewCollection);

export const getNewCollectionDefault = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridNewCollection?.default);

export const getNewCollectionDefaultPageIdsFiltered = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridNewCollection?.default.idsFiltered);

export const getNewCollectionStudio = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridNewCollection?.studio);

export const getNewCollectionStudioPageGridElements = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridNewCollection?.studio.pageGridElements);

export const getNewCollectionStudioGridElementsFiltered = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridNewCollection?.studio.gridElementsFiltered);

export const getNewCollectionTitle = createSelector(getGridState, (state: CategoryGrid) =>
    state?.gridNewCollection?.title);
// #endregion

// PUBLIC API
export const getTotalQuantityProducts = createSelector(getGridState, (state: CategoryGrid) => state?.totalQuantityProducts);
export const getGridType = createSelector(getGridState, (state: CategoryGrid) => state?.gridType);

export const getGridCategory = createSelector(getGridState, (state: CategoryGrid) => state?.categoryId);

export const getGridInfo = createSelector(getGridState, (state: CategoryGrid) => {
    return {
        gridType: state?.gridType,
        gridDefault: state?.gridDefault,
        gridStudio: state?.gridStudio,
        gridNewCollection: state?.gridNewCollection,
    };
});
